var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { getCookie } from '../utils/util';
import { USER_INFO_REQUEST, USER_INFO_SUCCESS, USER_INFO_FAILURE, CATEGORY_REQUEST, CATEGORY_SUCCESS, CATEGORY_FAILURE, } from '../reducers/common';
// user
function userInfoAPI() {
    var url = '/front/v2/user/info';
    var auth_token = getCookie('auth_token');
    var config = {
        withCredentials: true,
        xsrfHeaderName: 'Authorization',
    };
    return axios.post(url, { auth_token: auth_token }, config);
}
function userInfo() {
    var result, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(userInfoAPI)];
            case 1:
                result = _a.sent();
                return [4 /*yield*/, put({
                        type: USER_INFO_SUCCESS,
                        data: result.data,
                    })];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                console.error(e_1);
                return [4 /*yield*/, put({
                        type: USER_INFO_FAILURE,
                    })];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchUserInfo() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(USER_INFO_REQUEST, userInfo)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// category
export function categoryAPI(_a) {
    var idx_b_manager = _a.idx_b_manager, firstPlaceCateId = _a.firstPlaceCateId;
    var newCateId = firstPlaceCateId === '2' ? '2' : '1';
    var url = "/front/v3/item/cate/".concat(newCateId);
    var config = {
        withCredentials: true,
        xsrfHeaderName: 'Authorization',
        params: {
            idx_b_manager: idx_b_manager || 1,
        },
    };
    return axios.get(url, config);
}
function category(action) {
    var result, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call(categoryAPI, action.payload)];
            case 1:
                result = _a.sent();
                return [4 /*yield*/, put({
                        type: CATEGORY_SUCCESS,
                        data: result.data.result.cate,
                    })];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                console.error(e_2);
                return [4 /*yield*/, put({
                        type: CATEGORY_FAILURE,
                    })];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchCategory() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(CATEGORY_REQUEST, category)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function commonSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([fork(watchUserInfo)])];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([fork(watchCategory)])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/detail/sagas/common.ts
// module id = 80
// module chunks = 0